import { css } from 'lit';

export default css`
  :host {
    color: var(--sl-color-foreground-subtlest);
    display: block;
    inline-size: 100%;
  }

  .wrapper {
    padding: var(--sl-size-075);
    padding-inline-start: var(--sl-size-300);
  }

  .divider {
    border-block-start: var(--sl-color-elevation-border-raised) solid var(--sl-size-borderWidth-default);
    margin-block-start: var(--sl-size-100);
    padding-block-start: var(--sl-size-100);
  }
`;
